import { FC, useMemo } from 'react';

import { Log } from '@common/log-manager';
import { useInitLikedProducts } from '@widgets/like-product';
import {
  convertProductItemListToUxGoodsCardItemList,
  convertProductListToIdList,
  ShopUxProductCardItem,
  StoreHomeVerticalProductCardList,
  useEnvConfig,
} from '@domains/storehome-common';
import { ComponentProps } from '@domains/storehome-common';

interface UxProductListProps extends ComponentProps<ShopUxProductCardItem[]> {
  log?: Partial<Log>;
  use_impression?: boolean;
  columnCount?: 2 | 3;
}

export const UxProductList: FC<React.PropsWithChildren<UxProductListProps>> = ({
  component,
  log,
  use_impression,
  columnCount,
}) => {
  const { is_zigzag } = useEnvConfig();
  const products = useMemo(
    () => convertProductItemListToUxGoodsCardItemList({ item_list: component, is_zigzag, show_ranking: false }),
    [component, is_zigzag],
  );
  useInitLikedProducts({
    data: products,
    convert: convertProductListToIdList,
  });

  if (products instanceof Array === false || products.length === 0) {
    return null;
  }

  return (
    <StoreHomeVerticalProductCardList
      item_list={products}
      log={log}
      useImpression={use_impression}
      columnCount={columnCount}
    />
  );
};
